import { TextBlockCms } from '@cerifi/ui/cms/text-block/text-block.cms'

import { ContentTypeRichText } from '../../../__generated/graphql.types'

const RichText = (props: { content: ContentTypeRichText }) => {
  return (
    <TextBlockCms
      isH1={(props.content as any).IS_H1}
      id={props.content.sys.id}
      title={props.content.title}
      text={props.content.content}
      orientation={props.content.alignment as any}
      color={props.content.color}
      padding={props.content.padding || false}
      button={props.content.button}
      secondaryButton={props.content.secondaryButton}
      numberOfColumns={props.content.numberOfColumns || undefined}
      mobileNumberOfColumns={props.content.mobileNumberOfColumns || undefined}
    />
  )
}

export default RichText
